// @flow

import _ from 'lodash';
import React from 'react';

import VideoLayout from './../../../modules/UI/videolayout/VideoLayout';

import { obtainConfig } from '../../features/base/config';
import { connect, disconnect } from '../../features/base/connection';
import { translate } from '../../features/base/i18n';
import { connect as reactReduxConnect } from '../../features/base/redux';
import { Chat } from '../../features/chat';
import { Filmstrip } from '../../features/filmstrip';
import { CalleeInfoContainer } from '../../features/invite';
import { LargeVideo } from '../../features/large-video';
import { LAYOUTS, getCurrentLayout } from '../../features/video-layout';
import { setAudioMuted, VIDEO_MUTISM_AUTHORITY, setVideoMuted } from '../../features/base/media';
import { fullScreenChanged, showToolbox, setToolboxAlwaysVisible, setFullScreen } from '../../features/toolbox/actions.web';
import { Toolbox } from '../../features/toolbox/components/web';
import { sendMessage } from './../../features/chat/actions';

import VideoMuteButton from '../../features/toolbox/components/VideoMuteButton';
import { toggleScreensharing } from '../../features/base/tracks';
import { getJobIdFromChat } from '../../features/base/conference';
import { toggleDocument } from '../../features/etherpad';

import { maybeShowSuboptimalExperienceNotification } from '../../features/conference/functions';
import { AbstractConference, abstractMapStateToProps } from '../../features/conference/components/AbstractConference';
import type { AbstractProps } from '../../features/conference/components/AbstractConference';
import { ACTION_SHORTCUT_TRIGGERED, VIDEO_MUTE, createShortcutEvent, createToolbarEvent, sendAnalytics } from '../../features/analytics';
import $ from 'jquery';
import SmallSection from "./SmallSection"
import { UnmuteIcon, MuteIcon, VideoUnmute, VideoMute, HangUp } from './Icons';
import ProcessLoader from './Helper/Loader';
import { clearMessages } from '../../features/chat/actions.any';

declare var APP: Object;
declare var config: Object;
declare var interfaceConfig: Object;

/**
 * DOM events for when full screen mode has changed. Different browsers need
 * different vendor prefixes.
 *
 * @private
 * @type {Array<string>}
 */
const FULL_SCREEN_EVENTS = [
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'fullscreenchange'
];

/**
 * The CSS class to apply to the root element of the conference so CSS can
 * modify the app layout.
 *
 * @private
 * @type {Object}
 */
const LAYOUT_CLASSNAMES = {
    [LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW]: 'horizontal-filmstrip',
    [LAYOUTS.TILE_VIEW]: 'tile-view',
    [LAYOUTS.VERTICAL_FILMSTRIP_VIEW]: 'vertical-filmstrip'
};

/**
 * The type of the React {@code Component} props of {@link Conference}.
 */
type Props = AbstractProps & {

    /**
     * Whether the local participant is recording the conference.
     */
    _iAmRecorder: boolean,

    /**
     * The CSS class to apply to the root of {@link Conference} to modify the
     * application layout.
     */
    _layoutClassName: string,

    dispatch: Function,
    t: Function
}

/**
 * The conference page of the Web application.
 */
class Conference extends AbstractConference<Props, *> {
    _onFullScreenChange: Function;
    _onShowToolbar: Function;
    _originalOnShowToolbar: Function;

    /**
     * Initializes a new Conference instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);

        // Throttle and bind this component's mousemove handler to prevent it
        // from firing too often.
        this._originalOnShowToolbar = this._onShowToolbar;
        this._onShowToolbar = _.throttle(
            () => this._originalOnShowToolbar(),
            100,
            {
                leading: true,
                trailing: false,
            });

        this.state = {
            activeClass: 'pencilTool',
            isFlip: false,
            sendScreenShot: 'N',
            intervalID: 0,
            workFlow: [],
            workTask: [],
            jobId: '',
            email: '',
            loading: false,
            imageUrl: '',
            signature: '',
            startTime: '',
            previewId: '',
            taskId: '',
            emailData: [],
            isNewWork: true,
            isSubmit: false,
            _jobId: '',
            activeTask: [0],
            screenShotLoader: false,
            workFlowEvent:''
        }
        // Bind event handler so it is only bound once for every instance.
        this._onFullScreenChange = this._onFullScreenChange.bind(this);
    }

    intervalID = 0;

    /**
     * Start the connection and get the UI ready for the conference.
     *
     * @inheritdoc
     */
    componentDidMount() {
        const { configLocation } = config;
        if (this.props._room === "login") {
            localStorage.clear();
            window.location.href = `${interfaceConfig.WEB_URL}`;
            return;
        }
        if (localStorage.getItem('user') !== null && JSON.parse(localStorage.getItem('user')).token) {
            this.validateRoom();
        } else {
            localStorage.clear();
            window.location.href = `${interfaceConfig.WEB_URL}`;
            return;
        }

        if (configLocation) {
            obtainConfig(configLocation, this.props._room)
                .then(() => {
                    const now = window.performance.now();

                    APP.connectionTimes['configuration.fetched'] = now;
                    console.log('(TIME) configuration fetched:\t', now);

                    this._start();
                })
                .catch(err => {
                    console.log(err);

                    // Show obtain config error.
                    APP.UI.messageHandler.showError({
                        descriptionKey: 'dialog.connectError',
                        titleKey: 'connection.CONNFAIL'
                    });
                });
        } else {
            this._start();
        }

        // window.onbeforeunload = function(event) {
        //     event.returnValue = "VR";
        // }

    }

    getWorkFlows = () => {
        const local = JSON.parse(localStorage.getItem('user'));
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/GetWorkflows`, {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
        });

        fetch(request).then(res => res.json()).then(res => {
            this.setState({ workFlow: res })
        }).catch(err => {

            console.log(err)
        });
    }

    validateRoom = () => {
        const local = JSON.parse(localStorage.getItem('user'));
        const key = this.props._room;
        const request = new Request(`${interfaceConfig.API_URL}/User/ValidateKey?key=${key}`, {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
        });

        fetch(request).then(res => res.json()).then(res => {
            console.log({ MESSAGE: res.msg })
            if (res.msg === "success") {
                this.getWorkFlows();
            }
            if (res.msg.includes("not registered")) {
                console.log("HERE--->")
                return this.registerRoom();
                // localStorage.clear();
                // window.location.href = `${interfaceConfig.WEB_URL}`;
            }
            return;
        }).catch(err => {

            localStorage.clear();
            window.location.href = `${interfaceConfig.WEB_URL}`;
        });
    }

    registerRoom = () => {
        console.log("HERE--->1")
        const local = JSON.parse(localStorage.getItem('user'));
        const key = this.props._room;
        const request = new Request(`${interfaceConfig.API_URL}/User/RegisterKey`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
            body: JSON.stringify({ userName: local.username, key })
        });
        fetch(request).then(res => {
            if (res.status !== 200) {
                localStorage.clear();
                return window.location.href = `${interfaceConfig.WEB_URL}`;
            } else {
                this.validateRoom();
            }
        })
    }

    _closeWhiteBoard = () => {

        $('#etherpadIFrame').contents().find('#clearTool').click();
        $('#etherpadIFrame').contents().find("#image_id").attr('src', '');
        sendAnalytics(createToolbarEvent(
            'toggle.etherpad',
            {
                enable: !this.props._editingDocument
            }));
        clearInterval(this.intervalID)
        this.props.dispatch(toggleDocument());
        const data = {
            ...{ type: 0 }, ...{ img: "" }
        }
        this.props.dispatch(sendMessage(JSON.stringify(data)));
        this.setState({ activeClass: 'pencilTool' })
        sendAnalytics(createToolbarEvent(VIDEO_MUTE, { enable: false }));
        this.props.dispatch(setVideoMuted(false, VIDEO_MUTISM_AUTHORITY.USER, /* ensureTrack */ true));

        // const videoElem = document.querySelector('#localVideo_container');
        // let tracks = videoElem.srcObject.getTracks();
        // tracks.forEach(track => track.stop());
    }


    _onToolbarToggleScreenshare = () => {
        if (!this.props._desktopSharingEnabled) {
            return;
        }

        sendAnalytics(createShortcutEvent(
            'toggle.screen.sharing',
            ACTION_SHORTCUT_TRIGGERED,
            { enable: !this.props._screensharing }));

        this._doToggleScreenshare();
    }

    _doToggleScreenshare = () => {
        if (this.props._desktopSharingEnabled) {
            APP.store.dispatch(toggleScreensharing());
        }
    }

    /**
     * Calls into legacy UI to update the application layout, if necessary.
     *
     * @inheritdoc
     * returns {void}
     */
    componentDidUpdate(prevProps, prevState) {
        // console.log(localStorage.getItem('sShot'),prevState)
        try {
            if (APP?.conference?.isJoined() && prevProps?._messages !== this?.props?._messages) {
                if (this?.props?._messages?.length > 0) {
                    let workFlowList = this?.props?._messages?.filter(v => JSON?.parse(v.message)?.type === 'workflow')
                    let workFlow = JSON.parse(workFlowList[workFlowList.length - 1]?.message)
                    let isLocal = workFlow?.isLocal??false
               
                    if (!isLocal) {
                        this.DisplayWorkFlow(workFlow)
                        APP.store.dispatch(clearMessages());
                    } else {
                        $('#mainTask').text(workFlow.name)
                    }

                    
                }
            }
        }
        catch (err) {
            console.log(err)
        }
        if (this.props._shouldDisplayTileView
            === prevProps._shouldDisplayTileView) {
            return;
        }

        // TODO: For now VideoLayout is being called as LargeVideo and Filmstrip
        // sizing logic is still handled outside of React. Once all components
        // are in react they should calculate size on their own as much as
        // possible and pass down sizings.
        VideoLayout.refreshLayout();
    }

    /**
     * Disconnect from the conference when component will be
     * unmounted.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        APP.UI.unbindEvents();

        FULL_SCREEN_EVENTS.forEach(name =>
            document.removeEventListener(name, this._onFullScreenChange));

        APP.conference.isJoined() && this.props.dispatch(disconnect());
    }

    DisplayWorkFlow=(e)=>{
        console.log('e========================',e)
        $('#mainTask').text('');
        $('#activeTask').text('');
        $('#modalDiv').empty();
        $('.btnEn').attr('disabled', false);
        $('input[type="checkbox"]').prop("checked", false).change();
        $('input[type="checkbox"]').prop('disabled', false);
        $('p').removeClass('text-selected');

        const date = new Date();
        this.setState({ isNewWork: false ,workFlowEvent:e.id})
        $('#mainTask').text(e?.description);
        $('#editFlowName').val(e.name);
        $('#editFlowName').attr('data', e.id);
        const flowTask = this.state.workFlow.filter(val => val.id ===  e.id)[0].workflowTask;
        const activeIndex = flowTask.findIndex(v=> v?.name?.toLowerCase() === e?.name?.toLowerCase())
        console.log("flowTask=====================",activeIndex)
        let divHtml = '';
        flowTask.forEach((val, i) => {
            divHtml += ` <div class="form-group contentrow" id="editInput_${i}">
          <div class="row">
              <div class="col-md-1 count">
                  ${i + 1}.
              </div>
              <div class="col-md-8 textareawrap" >
                  <input type="text" data-id="${val.id}"  name="newWorkFlow" value="${val.name}" class="form-control" />
              </div>
              <div class="col-md-2 p-0">
                  <button class="btn btn-danger btnRemove ${i === 0 ? 'hide' : ''}" onclick="$(this).closest('.contentrow').remove()"><i class="fa fa-times"></i></button>
              </div>
          </div>
      </div>`;
        })

        $('#modalDiv').append(divHtml);
       
        this.setState({ workTask: flowTask, startTime: date.toISOString() });
        $('#activeTask').text(e.name);
        $('p').removeClass('strike');
        $('.btn-snapshot').removeClass('hide');
        $('.taskDone').addClass('hide');
        $('.previewimg').addClass('hide');
        $("#formDiv .p-text").removeClass('text-selected');
        $(`#task_${activeIndex}`).addClass('text-selected');
    }

    componentWillReceiveProps(newProps) {
        if (newProps._jobId !== undefined && newProps._jobId.jobId !== this.state._jobId) {
            document.getElementById("tasks").value = newProps._jobId.workflowTaskId;
            this.setState({ jobId: newProps._jobId.jobId, _jobId: newProps._jobId.jobId, startTime: new Date().toISOString() });
            this.getWorkFlowFromJobId(newProps._jobId.jobId);
        }
        //     // console.log(window.frames.localStorage)
        //     // if (document.getElementsByTagName('iframe')[0] !== undefined) {
        //     //     console.log(document.getElementsByTagName('iframe')[0].contentWindow)
        //     //     let iframeStorage = document.getElementsByTagName('iframe')[0].contentWindow.localStorage.getItem('sShot');
        //     //     if (iframeStorage !== null && iframeStorage !== this.state.intervalID) {
        //     //         console.log(iframeStorage, this.state.intervalID)
        //     //     }
        //     //     this.setState({ intervalID: iframeStorage })
        //     // }

    }

    _shouldShowButton(buttonName) {
        return this.props._visibleButtons.has(buttonName);
    }

    _doToggleFullScreen() {
        const fullScreen = !this.props._fullScreen;

        this.props.dispatch(setFullScreen(fullScreen));
    }

    add2canvas = (canvas, imageObj) => {

        const cwidth = window.$('#largeVideo').width();
        const cheight = window.$('#largeVideo').height();

        return new Promise((resolve, reject) => {
            if (!imageObj || typeof imageObj != 'object') {
                return reject();
            }
            else {
                var image = new Image(cwidth, cheight);
                image.onload = function () {
                    canvas.getContext('2d').drawImage(this, 0, 0);
                    resolve();
                };
                image.src = imageObj.src;
            }

        });


    }

    sendScreenShot = (e, id = "k") => {

        const canvas = $('#etherpadIFrame').contents().find("#myCanvas")[0];

        const images = [
            { src: canvas.toDataURL('image/png') },
            { src: $('#etherpadIFrame').contents().find("#image_id")[0].getAttribute('src') }
        ];
        const cwidth = window.$('#largeVideo').width();
        const cheight = window.$('#largeVideo').height();

        const taskName = $(`#task_${id}`).text().replace(/\s/g, '_')

        var newCanvas = document.createElement('canvas');
        newCanvas.width = cwidth;
        newCanvas.height = cheight;

        const canvas1 = document.getElementById('myCanvas');
        const dataURL = canvas1?.toDataURL();
   

        Promise.all(images.map(imageObj => this.add2canvas(newCanvas, imageObj)))

            .then(() => {
                const local = JSON.parse(localStorage.getItem('user'));
                const request = new Request(`${interfaceConfig.API_URL}/Workflow/UploadBase64File`, {
                    method: "POST",
                    headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
                    body: JSON.stringify({ fileName: `${taskName}_${this.state.jobId}.png`, base64Filecontentstring: newCanvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, "") })
                });

                fetch(request).then(res => res.json()).then(res => {
                    if (id !== "k") {
                        // $(`#btn_${id}`).removeClass('hide');
                        $(`#upl_${id}`).addClass('hide');
                        $(`#prv_${id}`).removeClass('hide');
                        this.setState({ activeTask: [id + 1] })
                        $(`#img_${id}`).attr('src', res.imageUrl + res.signature);
                        if ($('#previewImage').hasClass('show')) {
                            $('#modalImg').attr('src', res.imageUrl + res.signature);
                            // $('#retakeSubmit').removeClass('hide');
                        } else {
                            $('#modalImg').attr('src', '');
                        }

                        this.setState({ imageUrl: res.imageUrl, signature: res.signature });
                        this.doneTask(id, $(`#upl_${id}`).attr('data'))
                    } else {
                        const data = { ...{ type: 1 }, ...{ img: res.imageUrl + res.signature } }
                        this.props.dispatch(sendMessage(JSON.stringify(data)));
                    }

                })
            });
    }


    screenShot = async () => {
        this.setState({ screenShotLoader: true })
        const cwidth = window.$('#largeVideo').width();
        const cheight = window.$('#largeVideo').height();
        const canvas = document.createElement('canvas');
        canvas.width = cwidth;
        canvas.height = cheight;

        const ctx = canvas.getContext('2d');
        const img = document.getElementById('largeVideo');
        ctx.drawImage(img, 0, 0, cwidth, cheight);

        let imagedata = canvas.toDataURL('image/png');

        let imgdata = imagedata.replace(/^data:image\/(png|jpg);base64,/, "");
        const local = JSON.parse(localStorage.getItem('user'));
        const canvas1 = document.getElementById('myCanvas');
        const dataURL = canvas1?.toDataURL();
     
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/UploadBase64File`, {
            method: "POST",
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
            body: JSON.stringify({ fileName: `${Math.random().toString(36).substring(8)}.png`, base64Filecontentstring: imgdata })
        });

        await fetch(request).then(res => res.json()).then(res => {
            const data = {
                ...{ type: 1 }, ...{ img: `${res.imageUrl}${res.signature}` }
            }

            this.props.dispatch(sendMessage(JSON.stringify(data)));
        })

        sendAnalytics(createToolbarEvent(VIDEO_MUTE, { enable: true }));
        this.props.dispatch(setVideoMuted(true, VIDEO_MUTISM_AUTHORITY.USER, /* ensureTrack */ true));

        sendAnalytics(createToolbarEvent(
            'toggle.etherpad',
            {
                enable: !this.props._editingDocument
            }));

        let res = await this.props.dispatch(toggleDocument());
        if (res) this.setState({ screenShotLoader: false })

        if ($('#etherpadIFrame').contents().find("#image_id").attr('src') === undefined) {
            this.intervalID = setInterval(() => { $('#etherpadIFrame').contents().find("#image_id").attr('src', imagedata); }, 1000);
        } else {
            $('#etherpadIFrame').contents().find("#image_id").attr('src', imagedata);
            clearInterval(this.intervalID)
        }

    }


    drawImage = () => {
        const canva = $('#etherpadIFrame').contents().find("#myCanvas")[0];
        const img = $('#etherpadIFrame').contents().find("#image_id")[0]
        const ctx = canva.getContext('2d');
        ctx.drawImage(img, 0, 0)
    }


    selectDrawType = (id) => {
        if (id === 'colorToggle') {
            $('#etherpadIFrame').contents().find('#colorToggle > a > span').click()
        } else {
            $('#etherpadIFrame').contents().find(`#${id}`).click();
        }

        this.setState({ activeClass: id });
    }

    flipVideo = () => {
        this.setState({ isFlip: !this.state.isFlip })

    }

    createJob = (flowID) => {
        const local = JSON.parse(localStorage.getItem('user'));
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/CreateJob`, {
            method: "POST",
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
            body: JSON.stringify({ userId: local.id, workFlowId: flowID })
        });
        fetch(request).then(res => res.json()).then(res => {
            this.sendWorkflowEvent({ userId: local.id, workFlowId: flowID })
            this.setState({ jobId: res })
        });
    }

    sendWorkflowEvent = (value) => {
        const { sendCommand } = APP?.conference?.commands;
        sendCommand("workflow_event", { value, attributes: value })
    }

    getTask = (e) => {
        $('#mainTask').text('');
        $('#activeTask').text('');
        $('#modalDiv').empty();
        $('.btnEn').attr('disabled', false);
        $('input[type="checkbox"]').prop("checked", false).change();
        $('input[type="checkbox"]').prop('disabled', false);
        $('p').removeClass('text-selected');

        if (e.target.value === "Select") {
            $('#mainTask').text('');
            $('#activeTask').text('');
            this.setState({ workTask: [], isNewWork: true });
            const data = {
                ...{ type: "taskRemoved" }, ...{ msg: '' }
            }
            this.props.dispatch(sendMessage(JSON.stringify(data)));
            return;
        }
        const index = e.nativeEvent.target.selectedIndex;
        const date = new Date();
        const selectText = e.nativeEvent.target[index].text;
        $('#mainTask').text(selectText);
        this.setState({ isNewWork: false })
        $('#editFlowName').val(selectText);
        $('#editFlowName').attr('data', e.target.value);

        this.setState({workFlowEvent:e.target.value})
        this.createJob(e.target.value);
         

        const flowTask = this.state.workFlow.filter(val => val.id === e.target.value)[0].workflowTask;
        let divHtml = '';
        flowTask.map((val, i) => {
            divHtml += ` <div class="form-group contentrow" id="editInput_${i}">
          <div class="row">
              <div class="col-md-1 count">
                  ${i + 1}.
              </div>
              <div class="col-md-8 textareawrap" >
                  <input type="text" data-id="${val.id}"  name="newWorkFlow" value="${val.name}" class="form-control" />
              </div>
              <div class="col-md-2 p-0">
                  <button class="btn btn-danger btnRemove ${i === 0 ? 'hide' : ''}" onclick="$(this).closest('.contentrow').remove()"><i class="fa fa-times"></i></button>
              </div>
          </div>
      </div>`;
        })

        // <button class="btn btn-primary" data-id="${val.id}" onclick="$(this).closest('.contentrow').clone().appendTo('#modalDiv').find('input').attr('data-id','').val('')"><i class="fa fa-plus"></i></button>

        $('#modalDiv').append(divHtml);

        const data = {
            ...{ type: "workflow" }, ...{ msg: flowTask[0], isLocal: true, ...{ workFlow: e.nativeEvent.target[index].text } }
        }
        
        this.props.dispatch(sendMessage(JSON.stringify(data)));

        this.setState({ workTask: flowTask, startTime: date.toISOString() });
        $('#activeTask').text(flowTask[0].name);
        $('p').removeClass('strike');

        $('.btn-snapshot').removeClass('hide');
        $('.taskDone').addClass('hide');
        $('.previewimg').addClass('hide');
        $('#task_0').addClass('text-selected');
    }

    getWorkFlowFromJobId = (id) => {
        const local = JSON.parse(localStorage.getItem('user'));
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/GetWorkflowJob?jobId=${id}`, {
            method: "GET",
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
        });
        fetch(request).then(res => res.json()).then(res => {
            let task = document.getElementById('tasks');
            let flowTask = this.state.workFlow.filter(val => val.id === task.options[task.selectedIndex].value)[0].workflowTask;
            for (let i = 0; i < res.length; i++) {
                flowTask[flowTask.findIndex(v => v.id === res[i].id)] = res[i];
            }

            this.setState({ workTask: flowTask, activeTask: [res.length], isNewWork: false });
            $('#mainTask').text(task.options[task.selectedIndex].text);
            $('#activeTask').text(flowTask[res.length].name);
            $(`#task_${res.length}`).addClass('text-selected');
            const data = {
                ...{ type: "task" }, ...{ msg: flowTask[res.length], ...{ workFlow: task.options[task.selectedIndex].text } }
            }

            this.props.dispatch(sendMessage(JSON.stringify(data)));

        });
    }

    //  toDataURL=(src, callback, outputFormat)=> {
    //     let image = new Image();
    //     image.crossOrigin = 'Anonymous';
    //     image.onload = function () {
    //       let canvas = document.createElement('canvas');
    //       let ctx = canvas.getContext('2d');
    //       let dataURL;
    //       canvas.height = this.naturalHeight;
    //       canvas.width = this.naturalWidth;
    //       ctx.drawImage(this, 0, 0);
    //       dataURL = canvas.toDataURL(outputFormat);
    //       callback(dataURL);
    //     };
    //     image.src = src;
    //     if (image.complete || image.complete === undefined) {
    //       image.src = "data:image/gif;base64, R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    //       image.src = src;
    //     }
    //   }
    //   toDataURL('https://www.gravatar.com/avatar/0c6523b4d3f60hj548962bfrg2350',
    //     function (dataUrl) {
    //       console.log('RESULT:', dataUrl)
    //     }
    //   )

    uploadSnap = (e, id) => {
        // this.setState({loading:true});
        // $(`#btn_${id}`).removeClass('hide');

        $(`#upl_${id}`).addClass('hide');
        $(`#prv_${id}`).removeClass('hide');
        this.setState({ activeTask: [id + 1] })
        const cwidth = window.$('#largeVideo').width();
        const cheight = window.$('#largeVideo').height();
        const canvas = document.createElement('canvas');
        const taskName = $(`#task_${id}`).text().replace(/\s/g, '_')

        canvas.width = cwidth;
        canvas.height = cheight;

        const ctx = canvas.getContext('2d');
        const img = document.getElementById('largeVideo');
        ctx.drawImage(img, 0, 0, cwidth, cheight);

        let imagedata = canvas.toDataURL('image/png');
        const local = JSON.parse(localStorage.getItem('user'));

        const canvas1 = document.getElementById('myCanvas');
        const dataURL = canvas1?.toDataURL();
       
        // ${Math.random().toString(36).substring(7)}
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/UploadBase64File`, {
            method: "POST",
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
            body: JSON.stringify({ fileName: `${taskName}_${this.state.jobId}.png`, base64Filecontentstring: imagedata.replace(/^data:image\/(png|jpg);base64,/, "") })
        });

        fetch(request).then(res => res.json()).then(res => {

            $(`#img_${id}`).attr('src', res.imageUrl + res.signature);
            if ($('#previewImage').hasClass('show')) {
                $('#modalImg').attr('src', res.imageUrl + res.signature);

                // $('#retakeSubmit').hasClass('hide') ? $('#retakeSubmit').removeClass('hide') : ''
            } else {
                $('#modalImg').attr('src', '');

            }
            // $(`#prv_${id}`).attr('href', res.imageUrl+res.signature);
            this.setState({ imageUrl: res.imageUrl, signature: res.signature });
            this.doneTask(id, $(`#upl_${id}`).attr('data'));
        })
        e.preventDefault();
    }

    addNewInput(e) {
        const clone = $('#editInput_0').clone();

        clone.find('input').attr('data-id', '').val('')
        clone.find('.btnRemove').removeClass('hide')
        clone.find('.count').text(parseInt($('.count').map(function () { return $(this).text(); }).get().pop()) + 1)

        clone.appendTo('#modalDiv')
    }

    doneTask = (id, taskId) => {

        $(`#task_${id}`).addClass('strike');
        $(`#task_${id}`).removeClass('text-selected');
        $(`#task_${id + 1}`).addClass('text-selected');
        const { workTask } = this.state;
        const task = workTask[workTask.findIndex(val => val.id === taskId) + 1];
        const selectedWorkFlow = document.querySelector('#tasks');
        const data = {
            ...{ type: "task" }, ...{ msg: task }, ...{ workFlow: selectedWorkFlow.options[selectedWorkFlow.selectedIndex].text }
        }
        this.props.dispatch(sendMessage(JSON.stringify(data)));
        // document.querySelector(`#btn_${id} > input`).disabled = true;
        // document.querySelector(`#btn_${id} > input`).checked = true;
        const date = new Date();
        const comp = date.toISOString();
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/CreateWorkflowTaskJob`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${JSON.parse(localStorage.getItem('user')).token}` }),
            body: JSON.stringify({
                workflowTaskId: taskId,
                jobId: this.state.jobId,
                startTime: this.state.startTime,
                completeTime: comp,
                imageUrl: this.state.imageUrl
            })
        })
        fetch(request).then(res => res.text()).then(res => {
            this.setState({ previewId: '', taskId: '' });
            if ($('#previewImage').hasClass('show')) {
                // $('#retakeSubmit').addClass('hide');
                $('#previewImage').modal('hide');
            }
        })
        $('#activeTask').text(task.name);
    }

    submitTask = (e) => {
        if (localStorage.getItem('email') !== null) {
            const data = JSON.parse(localStorage.getItem('email'));
            data.filter(v => v === this.state.email) ? '' : data.push(this.state.email);

            localStorage.setItem('email', JSON.stringify(data));
        } else {
            localStorage.setItem('email', JSON.stringify([this.state.email]))
        }
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/MailJobStatus?jobId=${this.state.jobId}&email=${this.state.email}`, {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${JSON.parse(localStorage.getItem('user')).token}` })
        });
        if ((this.state.jobId).length > 0) {
            fetch(request).then(res => res.text()).then(res => {
                $('#myModal').modal('hide');
                this.setState({ email: '' });
            }).catch(err => {
                console.error(err)
            })
        } else {
            alert("please select task first");
        }
        e.preventDefault();
    }

    preViewImage = (id, taskId) => {
        this.setState({ previewId: id, taskId: taskId });
        $('#modalImg').attr('src', $(`#img_${id}`).attr('src'));
        $('#previewImage').modal('show');
    }

    openEmailModal = () => {
        console.log('open Email Modal')
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/GetAllEmails`, {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${JSON.parse(localStorage.getItem('user')).token}` })
        });
        fetch(request).then(res => res.json()).then(res => {
            this.setState({ emailData: res });
            $('#myModal').modal('show');
        });
    }

    editWorkFlowModal = (e) => {
        console.log('editWorkFlow')
        if (this.state.isNewWork) {
            $('#editFlowName').val('');
            let htmlData = '';
            [...Array(1).keys()].map((val, i) => {
                htmlData += `<div class="form-group contentrow ${i === 0 ? '' : 'hide'}" id="editInput_${i}">
                    <div class="row">
                        <div class="col-md-1 count">
                            ${i + 1}.
                        </div>
                        <div class="col-md-8 textareawrap" >
                            <input type="text" name="newWorkFlow" data-id=""  class="form-control" />
                        </div>
                        <div class="col-md-2 p-0">
                        <button class="btn btn-danger btnRemove hide" onclick="$(this).closest('.contentrow').remove()"><i class="fa fa-times"></i></button>
                        </div>
                    </div>
                </div>`
            })
            $('#modalDiv').append(htmlData);
        }
        $('#editWorkFlow').modal('show');
    }


    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        // console.log('%c isJoined','font-size:40px;color:green',this.props._isVideoHide)
        const {
            VIDEO_QUALITY_LABEL_DISABLED,

            // XXX The character casing of the name filmStripOnly utilized by
            // interfaceConfig is obsolete but legacy support is required.
            filmStripOnly: filmstripOnly
        } = interfaceConfig;
        const hideVideoQualityLabel
            = filmstripOnly
            || VIDEO_QUALITY_LABEL_DISABLED
            || this.props._iAmRecorder;

        const { _editingDocument } = this.props
        return (
            <div
                className={this.props._layoutClassName}
                id='videoconference_page'
                onMouseMove={this._onShowToolbar}>
                {/* <Notice /> */}
                <section id="main-body-section">
                    <aside id="aside">
                        <div class="aside-chat-head chat-header-fixed">
                            <div class="row emai-tabing1">
                                <div class="col-md-1 col-sm-2 col-lg-1 emai-tabing top_emi text-center">
                                    {/* <AudioMuteButton visible = { this._shouldShowButton('microphone') } /> */}
                                    {/* <a href="#" class="btn btn-top"><i class="fas fa-microphone"></i></a> */}
                                    {/* <a href="#" class="btn btn-top mt-85"><i class="fas fa-volume-up"></i></a> */}
                                    <div class="videoiconwrap">
                                        <VideoMuteButton visible={this._shouldShowButton('camera')} />
                                    </div>
                                    {/* <div class="toolbox-icon flipicon" onClick={() => this.flipVideo()} ><i class="fa-sync-alt fas"></i></div> */}
                                </div>
                                <div class="col-md-12 col-sm-12 text-center">
                                    <SmallSection />
                                </div>
                            </div>
                        </div>

                        <div class="tab-content chat-tab-content" >
                            <div className="col-md-12 asideForm">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-8 pr-0">
                                            <select className="form-control" id="tasks"
                                             value={this.state.workFlowEvent} onChange={(e) => this.getTask(e)}>
                                                <option>Select</option>
                                                {
                                                    this.state.workFlow && this.state.workFlow.map((val) => (
                                                    <option key={val.id} value={val.id}>{val.name}</option>))
                                                }
                                            </select>
                                        </div>

                                        <div className="col-md-4 pl-0 text-right">
                                            {this.state.isNewWork ? <button type="button" class="btn btn-blue add-btn" onClick={(e) => this.editWorkFlowModal(e)}></button> : <button type="button" class="btn btn-blue Edit-btn btnEn" onClick={(e) => this.editWorkFlowModal(e)}></button>}
                                            <button type="button" class="btn btn-blue Email-btn btnEn" onClick={(e) => this.openEmailModal(e)}></button>

                                            {/* <button onClick={(e) => this.submitTask(e)} className="btn btn-primary pull-right">Email</button> */}
                                        </div>
                                    </div>
                                </div>
                                {/* <form> */}
                                <div id="formDiv">
                                    {
                                        this.state.workTask.length > 0 && this.state.workTask.map((val, i) => {
                                            return (
                                                <div className="form-group contentrow">
                                                    <div className="row">
                                                        <div className="col-md-1">
                                                            {i + 1}.
                                                        </div>
                                                        <div className="col-md-8 textareawrap" >
                                                            <p id={`task_${i}`} className={`p-text ${i === 0 && !val.hasOwnProperty('imageUrl') ? 'text-selected' : val.hasOwnProperty('imageUrl') ? 'strike' : ''}`}>{val.name}</p>
                                                            {/* <input type="text" value={val.name} className="form-control" /> */}
                                                        </div>
                                                        <div className="col-md-2 p-0">
                                                            <a href="javascript:void(0)" onClick={() => this.preViewImage(i, val.id)} id={`prv_${i}`} className={`previewimg ${val.hasOwnProperty('imageUrl') ? '' : 'hide'}`}><img id={`img_${i}`} src={val.hasOwnProperty('imageUrl') ? `${val.imageUrl}` : `../../../images/img/gallery_icon.png`} /></a>
                                                            <button disabled={!this.state.activeTask.includes(i)} type="button" id={`upl_${i}`} data={val.id} onClick={(e) => this.props._editingDocument ? this.sendScreenShot(e, i) : this.uploadSnap(e, i)} className={`btn-block btn-blue btn-snapshot ${val.hasOwnProperty('imageUrl') ? 'hide' : ''}`}><i className="fa fa-camera-retro"></i></button>
                                                        </div>
                                                        {/* <div id={`btn_${i}`} className="col-md-1 p-0 hide taskDone">
                                                        <input type="checkbox" onChange={() => this.doneTask(i, val.id)} className="abso-icon" />
                                                    </div> */}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                {/* </form> */}
                            </div>
                        </div>
                    </aside>
                    <div id="bside-main-sec">
                        <bside id="bside">
                            <div class=" main_video">
                                <div class="row">
                                    <div class="col-md-1 col-sm-2 col-lg-1 emai-tabing emi_tab_bottom text-center">
                                        {/* onClick={() => this._onToolbarToggleScreenshare()} */}
                                        <button disabled={this.props._editingDocument} onClick={() => this.screenShot()}>
                                            <a href="javascript:void(0)" class="btn btn-top"><i class="fa fa-camera-retro"></i> </a>
                                        </button>

                                        {this.props._editingDocument ? <>
                                            <a href="javascript:void(0)" onClick={() => this.selectDrawType('pencilTool')} className={`btn btn-top ${this.state.activeClass === 'pencilTool' ? 'active' : ''}`}><i class="fas fa-pencil-alt"></i> </a>
                                            <a href="javascript:void(0)" onClick={() => this.selectDrawType('eraserTool')} className={`btn btn-top ${this.state.activeClass === 'eraserTool' ? 'active' : ''}`}><i class="fas fa-eraser"></i> </a>
                                            <a href="javascript:void(0)" onClick={() => this.selectDrawType('circleTool')} className={`btn btn-top ${this.state.activeClass === 'circleTool' ? 'active' : ''}`}><i class="far fa-circle"></i></a>
                                            <a href="javascript:void(0)" onClick={() => this.selectDrawType('rectangleTool')} className={`btn btn-top ${this.state.activeClass === 'rectangleTool' ? 'active' : ''}`}><i class="far fa-square"></i></a>
                                            <a href="javascript:void(0)" onClick={() => $('#etherpadIFrame').contents().find('#undoTool > span').click()} className={`btn btn-top ${this.state.activeClass === 'undoTool' ? 'active' : ''}`}><i class="fas fa-redo"></i></a>
                                            <a href="javascript:void(0)" onClick={() => this.selectDrawType('colorToggle')} className={`btn btn-top ${this.state.activeClass === 'colorToggle' ? 'active' : ''}`}><i class="fas fa-palette"></i></a>
                                            <a href="javascript:void(0)" onClick={() => this._closeWhiteBoard()} className={`btn btn-top`}><i class="fas fa-times"></i></a>

                                        </> : ''}
                                        <a href="javascript:void(0)" id="screenShot" onClick={(e) => this.sendScreenShot(e)} class="btn btn-top hide"><i class="fa fa-camera-retro"></i> </a>
                                    </div>

                                    <div class="col-md-11 col-sm-10 col-lg-11 inner_video no-padding text-center video_container">
                                        <div id='videospace'>

                                            {this.state.screenShotLoader ? <ProcessLoader /> : null}
                                            <>
                                                <p className="pull-left"><span id="mainTask"></span>-<span id="activeTask"></span></p>
                                                <div className="hide">
                                                    <Filmstrip filmstripOnly={filmstripOnly} />
                                                </div>
                                                <LargeVideo />
                                            </>
                                        </div>
                                        {!this.state.screenShotLoader &&
                                            <div className="toolbox-icon " style={{ cursor: "pointer" }}>
                                                <button className="tool-ico-btn " onClick={() => APP?.conference?.toggleAudioMuted()}>
                                                    <svg height="22" width="22" viewBox="0 0 25 25">
                                                        {APP?.conference?.isLocalAudioMuted() ? MuteIcon() : UnmuteIcon()}
                                                    </svg>
                                                </button>
                                                {/* <button className="tool-ico-btn "/>
                                               <VideoMuteButton/>  
                                               </button>                            */}
                                                <button className="tool-ico-btn " onClick={() => APP?.conference?.toggleVideoMuted()}>
                                                    <svg height="22" width="22" viewBox="0 0 22 22">
                                                        {APP?.conference?.isLocalVideoMuted() ? VideoMute() : VideoUnmute()}
                                                    </svg>
                                                </button>


                                                <button className="tool-ico-btn hangup-button " onClick={() => APP.conference.hangup()}>
                                                    <svg height="22" width="22" viewBox="0 0 32 32">
                                                        {HangUp()}
                                                    </svg>
                                                </button>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </bside>
                    </div>
                </section>

                <div class="modal fade" id="myModal" role="dialog">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">Job Status Email</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div className="form-group">
                                    <label>Enter email</label>
                                    <input name="email" value={this.state.email} className="form-control" onChange={(e) => this.setState({ email: e.target.value })} />
                                </div>
                                <div className="form-group">
                                    <label>Or select from the list</label>
                                    <select className="form-control" onChange={(e) => this.setState({ email: e.target.value })}>
                                        <option>Select</option>
                                        {
                                            (this.state.emailData.filter((v, i) => this.state.emailData.indexOf(v) === i)).map((data, i) => (<option value={data} key={i}>{data}</option>))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" onClick={(e) => this.submitTask(e)} class="btn btn-blue" >Submit</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="previewImage" role="dialog">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">Snapshot Preview</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="modal-body">
                                <img id="modalImg" src="" style={{ height: "auto", width: "100%" }} />
                            </div>
                            <div class="modal-footer">
                                <button type="button" onClick={(e) => this.props._editingDocument ? this.sendScreenShot(e, this.state.previewId) : this.uploadSnap(e, this.state.previewId)} class="btn btn-success">Retake</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="editWorkFlow" role="dialog">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h2>{this.state.isNewWork ? 'New' : 'Edit'} Task</h2>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div className="form-group contentrow">
                                    <div className="row">
                                        <div className="col-md-12 textareawrap" >
                                            <input type="text" id="editFlowName" data="" className="form-control" />
                                        </div>

                                    </div>
                                </div>
                                <div id="modalDiv">

                                </div>
                                <div class="form-group">
                                    <button class="btn btn-primary pull-right" onClick={(e) => this.addNewInput(e)}>Add Row</button>
                                </div>
                            </div>
                            <div class="modal-footer">
                                {this.state.isNewWork ? '' : <button type="button" class="btn btn-danger" disabled={this.state.isSubmit} onClick={(e) => this.deleteTask(e)} >Delete</button>}
                                <button type="button" class="btn btn-primary" disabled={this.state.isSubmit} onClick={(e) => this.createNewTask(e)} >{this.state.isSubmit ? 'Please wait...' : 'Submit'}</button>
                            </div>
                        </div>

                    </div>
                </div>


                {/* {filmstripOnly || <Toolbox />} */}
                {filmstripOnly || <Chat />}

                {this.renderNotificationsContainer()}

                <CalleeInfoContainer />
            </div>



        );
    }

    /**
     * Updates the Redux state when full screen mode has been enabled or
     * disabled.
     *
     * @private
     * @returns {void}
     */
    _onFullScreenChange() {
        this.props.dispatch(fullScreenChanged(APP.UI.isFullScreen()));
    }

    deleteTask = (e) => {
        const conf = confirm('Are you sure want to delete this task');
        if (conf === true) {
            this.setState({ isSubmit: true });
            const local = JSON.parse(localStorage.getItem('user'));
            const taskId = $('#editFlowName').attr('data');
            const request = new Request(`${interfaceConfig.API_URL}/Workflow?workflowId=${taskId}`, {
                method: "DELETE",
                headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
            });
            fetch(request).then(res => res.text()).then(res => {
                $('#modalDiv').empty()
                $('#editWorkFlow').modal('hide');
                $('#mainTask').text('');
                $('#activeTask').text('');
                $('#tasks').val('Select');
                this.setState({ workTask: [], isNewWork: true, isSubmit: false });
                this.getWorkFlows();
            });
        }
    }

    createNewTask = (e) => {
        this.setState({ isSubmit: true });
        const inputArr = $("input[name='newWorkFlow']").map(function () { return { id: $(this).attr('data-id'), name: $(this).val(), description: $(this).val(), order: 0 }; }).get();
        const workFlow = $('#editFlowName').val();


        const local = JSON.parse(localStorage.getItem('user'));
        const request = new Request(`${interfaceConfig.API_URL}/Workflow/CreateWorkflow`, {
            method: "POST",
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${local.token}` }),
            body: JSON.stringify({ id: $('#editFlowName').attr('data'), name: workFlow, description: workFlow, workflowTaskModel: inputArr.filter(val => val.name !== '') })
        });
        fetch(request).then(res => res.text()).then(res => {
            $('#modalDiv').empty()
            $('#editWorkFlow').modal('hide');
            $('#mainTask').text('');
            $('#activeTask').text('');
            $('#tasks').val('Select');
            this.setState({ workTask: [], isNewWork: true, isSubmit: false });
            this.getWorkFlows();
        });

        e.preventDefault();
    }

    /**
     * Displays the toolbar.
     *
     * @private
     * @returns {void}
     */
    _onShowToolbar() {
        this.props.dispatch(showToolbox());
    }

    /**
     * Until we don't rewrite UI using react components
     * we use UI.start from old app. Also method translates
     * component right after it has been mounted.
     *
     * @inheritdoc
     */
    _start() {
        APP.UI.start();

        APP.UI.registerListeners();
        APP.UI.bindEvents();

        FULL_SCREEN_EVENTS.forEach(name =>
            document.addEventListener(name, this._onFullScreenChange));

        const { dispatch, t } = this.props;

        dispatch(connect());
        // if(JSON.parse(localStorage.getItem('user')).token){
        //     this.validateRoom();
        // }else{
        //     console.log('%c Token','font-size:20px;color:green',JSON.parse(localStorage.getItem('user')));
        //     localStorage.clear();
        //     window.location.href = "https://vr.cap-tek.com";
        // }
        maybeShowSuboptimalExperienceNotification(dispatch, t);

        interfaceConfig.filmStripOnly
            && dispatch(setToolboxAlwaysVisible(true));
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code Conference} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
    const currentLayout = getCurrentLayout(state);

    const { fullScreen } = state['features/toolbox'];

    let { desktopSharingEnabled, jobId } = state['features/base/conference'];
    let desktopSharingDisabledTooltipKey;

    if (state['features/base/config'].enableFeaturesBasedOnToken) {
        // we enable desktop sharing if any participant already have this
        // feature enabled
        desktopSharingEnabled = getParticipants(state)
            .find(({ features = {} }) =>
                String(features['screen-sharing']) === 'true') !== undefined;

        // we want to show button and tooltip
        if (state['features/base/jwt'].isGuest) {
            desktopSharingDisabledTooltipKey
                = 'dialog.shareYourScreenDisabledForGuest';
        } else {
            desktopSharingDisabledTooltipKey
                = 'dialog.shareYourScreenDisabled';
        }
    }

    return {
        ...abstractMapStateToProps(state),
        _iAmRecorder: state['features/base/config'].iAmRecorder,
        _layoutClassName: LAYOUT_CLASSNAMES[currentLayout],
        _desktopSharingEnabled: desktopSharingEnabled,
        _jobId: jobId,
        _fullScreen: fullScreen,
        _desktopSharingDisabledTooltipKey: desktopSharingDisabledTooltipKey,
        _visibleButtons: new Set(interfaceConfig.TOOLBAR_BUTTONS),
        _editingDocument: Boolean(state['features/etherpad'].editing),
        _messages: state['features/chat'].messages
    };
}

export default reactReduxConnect(_mapStateToProps)(translate(Conference));
